import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-warning-icon",
  "use": "icon-warning-icon-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-warning-icon\">\n<circle cx=\"12\" cy=\"12\" r=\"8\" fill=\"#FF8541\" />\n<path d=\"M12 12L12 9\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<circle cx=\"1\" cy=\"1\" r=\"1\" transform=\"matrix(1 0 0 -1 11 16)\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol